/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {Dropdown1} from '../../../../_eLab/partials/content/dropdown/Dropdown1'
import {getCSSVariableValue} from '../../../../_eLab/assets/ts/_utils'
import {KTSVG} from '../../../../_eLab/helpers'
import {Link} from 'react-router-dom'
import {IDashboardModel} from '../../../models/master-page/DashboardModel'
import {getAdminCountApi} from '../../../modules/Dashboard/DashboardCURD'
import {toast} from 'react-toastify'

type Props = {
  className: string
  chartColor: string
  strokeColor: string
  chartHeight: string
}

interface IState {
  loading: boolean
  list: IDashboardModel
}
const MixedWidget2: React.FC<Props> = ({className, chartColor, chartHeight, strokeColor}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  let [state, setState] = useState<IState>({
    loading: false,
    list: {} as IDashboardModel,
  })

  useEffect(() => {
    setState({...state, loading: true})
    setTimeout(() => {
      fetchAdminCountList()
    }, 100)
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(chartHeight, chartColor, strokeColor)
    )
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef])

  function fetchAdminCountList() {
    getAdminCountApi()
      .then((response) => {
        let responseData = response.data
        if (responseData.isSuccess === true) {
          setState({...state, list: responseData, loading: false})
        } else {
          toast.error(`${responseData.message}`)
          setState({...state, list: {} as IDashboardModel, loading: false})
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState({...state, list: {} as IDashboardModel, loading: false})
      })
  }

  const {list} = state
  // Unified StatCard component
  const StatCard = ({
    to,
    title,
    count,
    color = 'primary',
  }: {
    to: string
    title: string
    count: number
    color?: 'primary' | 'success' | 'danger' | 'dark' | 'warning' | 'info'
  }) => (
    <div className='col-6 col-md-3'>
      {/* <div className={` border border-1 p-4 rounded-2 h-100`}> */}
      <div className={` border-start border-3 border-${color} p-4 rounded-2 h-100`}>
        <div className='text-dark text-decoration-none'>
          <div className='fw-bold fs-6'>{title}</div>
        </div>
        <p className={`fs-4 fw-bold text-primary mt-3 mb-0`}>{count}</p>
      </div>
    </div>
  )
  // Unified StatCard component
  const StattCard = ({
    to,
    title,
    count,
    color = 'primary',
  }: {
    to: string
    title: string
    count: number
    color?: 'primary' | 'success' | 'danger' | 'dark' | 'warning' | 'info'
  }) => (
    <div className='col-6 col-md-4'>
      {/* <div className={`border border-1 p-4 rounded-2 h-100`}> */}
      <div className={` border-start border-3 border-${color} p-4 rounded-2 h-100`}>
        <div className='text-dark text-decoration-none'>
          <div className='fw-bold fs-6'>{title}</div>
        </div>
        <p className={`fs-4 fw-bold text-primary mt-3 mb-0`}>{count}</p>
      </div>
    </div>
  )

  return (
    <>
      {/* <div className='card-header border-0'>
        <h3 className='card-title fw-bolder ms-5 text-primary'>eLab Statistics</h3>
      </div> */}

      <div className='bg-light py-4'>
        <div className='container'>
          {/* New Orders - By Customer */}
          <div className='card p-4 mb-4 shadow-sm rounded-3'>
            <h4 className='fw-semibold text-dark fs-5 mb-3'>
              New Orders - <span className='text-primary'>By Customer</span>
            </h4>
            <span className='border-1 border-bottom' />
            <div className='row g-4 mt-2 text-center'>
              <StatCard to='/countries' title='Test Lab' count={list.cusTestLab} color='warning' />
              <StatCard
                to='/states'
                title='Radiology Home'
                count={list.cusRedLogyHm}
                color='primary'
              />
              <StatCard
                to='/districts'
                title='Radiology Lab'
                count={list.cusRedLogyLab}
                color='danger'
              />
              <StatCard to='/districts' title='Health Care' count={list.cusHltCare} color='dark' />
            </div>
          </div>

          {/* New Orders - By Doctor */}
          <div className='card p-4 mb-4 shadow-sm rounded-3'>
            <h4 className='fw-semibold text-dark fs-5 mb-3'>
              New Orders - <span className='text-primary'>By Doctor</span>
            </h4>
            <span className='border-1 border-bottom' />
            <div className='row g-4 mt-2 text-center'>
              <StattCard
                to='/employee/employee'
                title='Test Lab'
                count={list.docTestLab}
                color='success'
              />
              <StattCard
                to='/customer'
                title='Radiology Home'
                count={list.cusRedLogyHm}
                color='success'
              />
              <StattCard to='/scripts' title='Radiology Lab' count={list.docTestLab} color='info' />
            </div>
          </div>

          {/* Orders Status */}
          <div className='card p-4 mb-4 shadow-sm rounded-3'>
            <h4 className='fw-semibold text-primary fs-5 mb-3'>Orders Status</h4>
            <span className='border-1 border-bottom' />
            <div className='row g-4 mt-2 text-center'>
              <StatCard
                to='/countries'
                title='Total Orders'
                count={list.totalOrder}
                color='warning'
              />
              <StatCard to='/states' title='Open Orders' count={list.openOrder} color='primary' />
              <StatCard
                to='/districts'
                title='Close Orders'
                count={list.closeOrder}
                color='danger'
              />
              <StatCard
                to='/districts'
                title='Under Process Orders'
                count={list.process}
                color='dark'
              />
            </div>
          </div>
          <div ref={chartRef} className='mixed-widget-2-chart card-rounded-bottom mt-4' />
        </div>
      </div>
    </>
  )
}

const chartOptions = (
  chartHeight: string,
  chartColor: string,
  strokeColor: string
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const color = getCSSVariableValue('--bs-' + chartColor)

  return {
    // series: [
    //   {
    //     name: 'Net Profit',
    //     data: [30, 45, 32, 70, 40, 40, 40],
    //   },
    // ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 3,
        color: strokeColor,
        opacity: 0.5,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 0,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [strokeColor],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: {
          color: borderColor,
          width: 1,
          dashArray: 3,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 80,
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val + ' thousands'
        },
      },
      marker: {
        show: false,
      },
    },
    colors: ['transparent'],
    markers: {
      colors: [color],
      strokeColors: [strokeColor],
      strokeWidth: 3,
    },
  }
}

export {MixedWidget2}
